import { ContextStylesParams, CSSObject } from '@mantine/core'

const placeholderStyle = {
    color: 'var(--mantine-text-placeholder)'
}

const SIZES: Record<string, { input: CSSObject }> = {
    xs: { input: { height: '3rem !important', '::placeholder': placeholderStyle } },
    sm: { input: { height: '3.6rem !important', '::placeholder': placeholderStyle } },
    md: { input: { height: '4.2rem !important', '::placeholder': placeholderStyle } },
    lg: { input: { height: '5rem !important', '::placeholder': placeholderStyle } },
    xl: { input: { height: '6rem !important', '::placeholder': placeholderStyle } }
}

export const getInputStyles = (props: ContextStylesParams): Record<string, CSSObject> => {
    const style = SIZES[props?.size] || {}

    return {
        ...style
    }
}
